import LocalStorage from './LocalStorage'

const ACCESS_TOKEN = 'access_token'
const REFRESH_TOKEN = 'refresh_token'

var AuthToken = {

    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    getToken: function(token_type) {
        var user = LocalStorage.getUser()
        if (user && user.data.auth_tokens[token_type]) {
            return user.data.auth_tokens[token_type]
        }
        return ''
    },

    setToken: function(token, token_type) {
        var user = LocalStorage.getUser()
        if (user && user.data.auth_tokens[token_type]) {
            user.data.auth_tokens[token_type] = token
            return LocalStorage.setUser(user)
        }
        return false
    },

    deleteToken: function(token_type) {
        var user = LocalStorage.getUser()
        if (user) {
            if (token_type == ACCESS_TOKEN && user.data.auth_tokens[token_type]){
                user.data.auth_tokens[token_type] = ''
                return LocalStorage.setUser(user)
            }
            else if (token_type == REFRESH_TOKEN){
                return LocalStorage.deleteUser()
            }
        }
        return false
    }
}

export default AuthToken
